<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <div class="text-h5">{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="themeList"
          sort-by="nome"
          :search="search"
          :custom-filter="filterOnlyCapsText"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="hidden-sm-and-down"
                    dark
                    color="blue"
                    right
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    novo
                  </v-btn>

                  <v-btn
                    class="hidden-md-and-up"
                    small
                    dark
                    fab
                    color="blue"
                    right
                    top
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ tituloModal }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-divider></v-divider>

                    <v-container>
                      <v-row>
                        <v-col cols="12" md="8">
                          <v-text-field
                            v-model="editedItem.nome"
                            label="Nome"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="auto">
                          <v-select
                            :items="specialtyList" 
                            v-model="editedItem.especialidade.idEspecialidade"
                            item-value="idEspecialidade"
                            item-text="nome"
                            label="Especialidade"
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                          <v-select
                            :items="itStatus"
                            v-model="editedItem.status"
                            label="Status"
                            hide-details
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import headers from '../../components/jsonsHelper/headers.json';
  import Tema from '../../models/tema'
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      url: 'tema/',
      tituloPagina: 'Cadastro de temas',
      headers: [],
      search: '',
      dialog: false,
      itStatus: ['Ativo', 'Inativo', 'A lancar'],
      editedIndex: -1,
      isEditingTheme: false,
      editedItem: new Tema(),
      defaultItem: new Tema(),
    }),

    computed: {
      ...mapState('theme', ['themeList']),
      ...mapState('specialty', ['specialtyList']),
      tituloModal() {
        return this.editedIndex === -1 ? 'Novo tema' : 'Editar tema';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      ...mapActions('theme', [ 'getThemeList',
        'deleteTheme', 'createTheme', 'changeThemeData',], 'editTheme'),
      ...mapActions('specialty', ['getSpecialtyList']),
      async initialize() {
        await this.getSpecialtyList();
        await this.getThemeList()
        this.headers = headers.temaHeaders;
      },

      filterOnlyCapsText(value, search) {
        search = search.toString().toLocaleUpperCase();
        return (
          value != null &&
          search != null &&
          typeof value === 'string' &&
          value
            .toString()
            .toLocaleUpperCase()
            .indexOf(search) !== -1
        );
      },

      editItem(item) {
        this.isEditingTheme = true;
        this.editedIndex = this.themeList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        confirm(
          'Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)',
        ) &&
          this.deleteTheme(item.idTema).then((status) => {
            status === 200 && this.getThemeList().then(() => this.close());
          });
      },

      close() {
        this.dialog = false;
        this.isEditingTheme = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        })
      },

      async save() {
        this.editedItem.idEspecialidade =this.editedItem.especialidade.idEspecialidade;
        let resp = this.isEditingItem
          ? await this.editTheme(this.editedItem)
          : await this.createTheme(this.editedItem);
        resp === 200 && this.getThemeList().then(() => this.close());
        this.close();
      },
    },
  };
</script>
